export default "__VITE_ASSET__a72a040a__"